import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { WashingtonSilhouette } from "./Logo";

const copyEmail = () => {
  if (navigator.clipboard?.writeText) {
    navigator.clipboard
      .writeText("sales@northwesttitlealliance.com")
      .then(() => toast.success("Email address copied — paste it into your mail app."))
      .catch(() => toast.info("Email us at sales@northwesttitlealliance.com"));
  } else {
    toast.info("Email us at sales@northwesttitlealliance.com");
  }
};

export const Footer = () => (
  <footer className="relative bg-navy border-t border-steel/30" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
        <div className="md:col-span-5">
          <img src="/assets/nwta-monogram.png" alt="Northwest Tech Alliance monogram" className="h-16 w-auto mb-6" />
          <p className="font-display font-bold tracking-[0.15em] text-fog text-sm uppercase">Northwest Tech Alliance</p>
          <p className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-tech-bright mt-2">
            AI · Software · Innovation
          </p>
          <div className="flex items-center gap-3 mt-6">
            <WashingtonSilhouette className="h-5 w-auto opacity-70" />
            <span className="font-mono-accent text-[10px] tracking-[0.25em] uppercase text-fog/40">Tacoma, WA</span>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-fog/40 mb-5">Products</p>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-link-axiom" to="/axiom" className="text-fog/60 hover:text-tech-bright transition-colors duration-300">The AXIOM Family</Link></li>
            <li><Link data-testid="footer-link-truenorth" to="/truenorth" className="text-fog/60 hover:text-tech-bright transition-colors duration-300">TrueNorth — Survey Intelligence</Link></li>
            <li><Link data-testid="footer-link-art" to="/art" className="text-fog/60 hover:text-tech-bright transition-colors duration-300">ART — AI Rendered Title</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono-accent text-[10px] tracking-[0.3em] uppercase text-fog/40 mb-5">The Family</p>
          <a
            href="https://northwesttitlealliance.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-title-site-link"
            className="group inline-flex items-start gap-2 text-sm text-fog/60 hover:text-fog transition-colors duration-300 leading-relaxed"
          >
            <span className="text-tech-bright">Visit Northwest Title Alliance</span>
            <ArrowUpRight className="h-4 w-4 mt-0.5 shrink-0 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
          </a>
          <div className="mt-8 space-y-2 text-sm text-fog/60">
            <p>Email: <a href="mailto:sales@northwesttitlealliance.com" onClick={copyEmail} data-testid="footer-sales-email" className="hover:text-tech-bright transition-colors duration-300">sales@northwesttitlealliance.com</a></p>
            <p>Sales: <a href="tel:+12534531754" data-testid="footer-sales-phone" className="hover:text-tech-bright transition-colors duration-300">(253) 453-1754</a></p>
            <p>Office: <a href="tel:+12535407333" data-testid="footer-office-phone" className="hover:text-tech-bright transition-colors duration-300">(253) 540-7333</a></p>
          </div>
        </div>
      </div>

      <div className="border-t border-steel/20 pt-8 flex flex-col md:flex-row justify-between gap-4">
        <p className="font-mono-accent text-[10px] tracking-[0.15em] text-fog/55" data-testid="footer-legal-text">
          © 2026 Northwest Title Alliance, DBA Northwest Tech Alliance. All rights reserved.
        </p>
        <p className="font-mono-accent text-[10px] tracking-[0.15em] text-fog/45">
          Underwriting-grade AI. Cited, not guessed. ·{" "}
          <a href="/resources" data-testid="footer-resources-link" className="hover:text-tech-bright transition-colors duration-300">
            Team resources
          </a>
        </p>
      </div>
    </div>
  </footer>
);
